import React from 'react';
import { Route, Switch } from "react-router-dom";
import AdcuCheckerReportsModule from './adcu-checker-reports-module/adcu-checker-reports-module';

const AdcuCheckerReports = () => {
  return (
    <Switch>
      <Route exact path="/tax-exempt-reports">
        <AdcuCheckerReportsModule />
      </Route>
    </Switch>
  )
}

export default AdcuCheckerReports;